<div class="socio-table table-responsive">
    <table class="table table-striped table-hover table-bordered">
        <thead>
            <tr>
                <th class="col-identificador">Tipo</th>
                <th class="col-cnpj-cpf">CNPJ/CPF</th>
                <th class="col-nome">Sócio</th>
                <th class="col-data-entrada text-center">Data Entrada</th>
                <th class="col-representante-legal">Representante Legal</th>
                <th class="col-faixa-etaria">Faixa Etária</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let socio of socios">
                <td class="col-identificador">
                    {{socio.identificador | socioIdentificador}}
                </td>
                <td class="col-cnpj-cpf">
                    {{socio.cnpjCpf}}
                </td>                
                <td class="col-nome">
                    {{socio.nome}}
                    <br/>
                    <small class="qualificacao-socio" *ngIf="socio.qualificacaoCodigo">
                        {{socio.qualificacaoCodigo}} - {{socio.qualificacaoNome}}
                    </small>
                </td>
                <td class="col-data-entrada text-center">
                    {{socio.dataEntradaSociedade | date: 'dd/MM/yyyy'}}
                </td>  
                <td class="col-representante-legal">                            
                    {{socio.representanteLegalNome}} <span *ngIf="socio.representanteLegalCpf"> ({{socio.representanteLegalCpf}})</span>
                    <br/>
                    <small class="qualificacao-socio" *ngIf="socio.representanteLegalqualificacaoCodigo">
                        {{socio.representanteLegalqualificacaoCodigo}} - {{socio.representanteLegalualificacaoNome}}
                    </small>
                </td>                      
                <td class="col-faixa-etaria">
                    {{socio.faixaEtariaNome}}
                </td>
            </tr>
            <tr *ngIf="!socios || socios.length == 0"> 
                <td colspan="6" class="text-center">
                    <i class='fas fa-info' aria-hidden='true'></i> {{emptyText}}
                </td>
            </tr>
        </tbody>
    </table>
</div>